import React, { forwardRef } from 'react';
import { cn } from './cn';

const VARIANTS = {
  ghost: 'text-fg-muted hover:bg-ink-100 hover:text-fg dark:hover:bg-ink-700',
  subtle: 'bg-surface border border-line text-fg-muted hover:bg-ink-50 hover:text-fg dark:hover:bg-ink-800',
  danger: 'text-danger-600 hover:bg-danger-50 dark:text-danger-500 dark:hover:bg-danger-500/10',
  primary:
    'bg-brand-600 text-white border border-brand-600 hover:bg-brand-500 hover:border-brand-500',
};

const SIZES = {
  sm: 'h-6 w-6 [&>svg]:w-[14px] [&>svg]:h-[14px] rounded',
  md: 'h-8 w-8 [&>svg]:w-4 [&>svg]:h-4 rounded-md',
  lg: 'h-9 w-9 [&>svg]:w-[18px] [&>svg]:h-[18px] rounded-md',
};

/**
 * IconButton — compact square button for row actions, toolbars, and menus.
 * Uses `title` for native tooltip; a real tooltip primitive can land later.
 */
export const IconButton = forwardRef(function IconButton(
  {
    as: Comp = 'button',
    variant = 'ghost',
    size = 'md',
    tooltip,
    className,
    children,
    type,
    ...rest
  },
  ref,
) {
  const isButton = Comp === 'button';
  return (
    <Comp
      ref={ref}
      type={isButton ? type || 'button' : undefined}
      aria-label={tooltip}
      title={tooltip}
      className={cn(
        'inline-flex items-center justify-center transition-colors duration-150 ease-out-soft',
        'focus-visible:outline-none focus-visible:shadow-focus-ring',
        'disabled:cursor-not-allowed disabled:opacity-50',
        SIZES[size],
        VARIANTS[variant],
        className,
      )}
      {...rest}
    >
      {children}
    </Comp>
  );
});

export default IconButton;
